/**
 * This piece of code is responsible for obtaining GPS coordinates and sending them to server.
 *
 * @author Vašek Brychta <mail@vasekbrychta.cz>
 */

(function (window, $, Foundation, undefined) {

	if (typeof $ !== 'function') {
		return console.error('brko.gpsChecker.js: jQuery is missing, load it please');
	}

	var gpsChecker = function () {
		var inner = {
			watchId: 0,
			lastPosition: undefined,
			reportingUrl: undefined,
			options: {
				enableHighAccuracy: true,
				timeout: 30000,
				maximumAge: 3000
			},
			clearWatch: function () {
				if (inner.watchId !== 0) {
					navigator.geolocation.clearWatch(inner.watchId);
					inner.watchId = 0;
				}
			},
			onSuccess: function (position) {
				const simplified = {
					coords: {
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
						accuracy: position.coords.accuracy,
						altitude: position.coords.altitude,
						altitudeAccuracy: position.coords.altitudeAccuracy,
						heading: position.coords.heading,
						speed: position.coords.speed
					},
					timestamp: position.timestamp
				};

				var newPosition = Immutable.Map(simplified);
				if ((inner.lastPosition === undefined)
					|| ((newPosition.timestamp - inner.lastPosition.timestamp) > 900 && !inner.lastPosition.equals(newPosition))) {
					inner.lastPosition = newPosition;
					inner.reportLocation(simplified);
				}
			},
			onError: function (error) {
				console.error('ERROR(' + error.code + '): ' + error.message);
				inner.reportLocation({
										 error: {
											 code: error.code,
											 message: error.message
										 },
										 timestamp: +new Date()
									 });
			},
			reportLocation: function (data) {
				$.nette.ajax({
								 url: inner.reportingUrl,
								 method: 'post',
								 data: data,
								 off: ['history', 'scrollTo', 'nprogress']
							 }, $(this));
			}
		};

		this.reset = function () {
			inner.clearWatch();
			inner.reportingUrl = undefined;
		};

		/**
		 * @param {Object} options
		 * @param {string} options.reportingUrl
		 */
		this.start = function (options) {
			this.reset();
			if (options.reportingUrl === undefined) {
				console.error('ERROR: No reporting url given!');
				return;
			}

			inner.reportingUrl = options.reportingUrl;

			if (navigator.geolocation) {
				inner.watchId = navigator.geolocation.watchPosition(inner.onSuccess, inner.onError, inner.options);
			} else {
				inner.onError({code: 255, message: window.brko.translations['game.general_error.gps_not_supported']});
			}
		};
	};

	if (window.brko === undefined) {
		window.brko = new (function () {
		});
	}

	window.brko.gpsChecker = new gpsChecker();

})(window, window.jQuery, window.Foundation);
